import { OnboardingTooltip } from '@cian/ui-kit';
import * as React from 'react';
import { ChatOnboardingContent } from 'shared/components/ChatOnboardingContent';
import { TAllOfferChatOnboardings } from 'shared/types/chatOnboarding';

import { useChatOnboarding } from './hooks/useChatOnboarding';

interface IChatOnboardingContainerProps {
  children: React.ReactElement;
  type: keyof TAllOfferChatOnboardings;
}

export const ChatOnboardingContainer: React.FC<IChatOnboardingContainerProps> = ({ children, type }) => {
  const { open, onboardingText, closeHandler } = useChatOnboarding(type);

  if (!open) {
    return children;
  }

  return (
    <OnboardingTooltip
      theme="black"
      content={<ChatOnboardingContent>{onboardingText}</ChatOnboardingContent>}
      placement="left"
      portal={false}
      open={open}
      onClose={closeHandler}
      flip={false}
    >
      <div>{children}</div>
    </OnboardingTooltip>
  );
};
